// extracted by mini-css-extract-plugin
export default {"zoomModal":"O3-z"};